export class SearchPulldown {
  constructor(trigger) {
    if (!trigger) return;
    this.search = document.querySelector('.js-search-pulldown');
    trigger.addEventListener('click', () => {
      document.body.classList.toggle('is-pulldown');
      if (document.body.classList.contains('is-pulldown')) {
        this.search?.querySelector('input')?.focus();
      }
    });
  }
}
